import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import SelectCampusMultiChoice from "../../../SelectCampusMultiChoice";
import { useEffect, useState } from "react";
import SelectCampus from "../../../SelectCampus";
import FinancialDatePicker from "../FinancialDatePicker";
import { DateTableType } from "../../../../constans";
import { DatePicker, Table, TableColumnsType } from "antd";
import moment from "moment";
import Button from "../../../Button";
import { IExpenseList, IExpenseListParams, IGetExpenseList, IGetIncomeList, IGetStudentIncome, IIncomeList, IIncomeListParams, IStudentIncome, IStudentIncomeParams } from "../../../../models/financials.model";
import config from "../../../../lib/config";
import DownloadButton from "../../../DownloadButton";
import Pagination from "../../../Pagination";
import useAxios from "../../../../hooks/useAxios";
import { getExpenses, getIncomes, getStudentIncomes } from "../../../../api/financials.api";
import { getCommonCodeLabel } from "../../../../lib/store";
import useNotification from "../../../../hooks/useNotification";
import exportTable from "../../../../lib/exportTable";
import Loader from "../../../Loader";

const IncomeExpenseList = () => {

    const pageSize = 10;
    const maxPageSize = 9999999;
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { infoNotification } = useNotification();

    const [campusCodes, setCampusCodes] = useState<string[]>([]);
    const [srtDate, setSrtDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [defSelType, setDefSelType] = useState<number>(0);
    const [page, setPage] = useState(1);
    const [inPage, setInPage] = useState(1);
    const [exPage, setExPage] = useState(1);
    const [studentIncomeRefineList, setStudentIncomeRefineList] = useState<IStudentIncome[]>([]);
    const [incomeRefineList, setIncomeRefineList] = useState<IIncomeList[]>([]);
    const [expenseRefineList, setExpenseRefineList] = useState<IExpenseList[]>([]);
    const [exportTableLoading, setExportTableLoading] = useState(false);

    const {data: studentIncomeList, isLoading: isLoading1, error: error1, execute: executeList } = useAxios<IGetStudentIncome>();
    const {data: incomeList, isLoading: isLoading2, error: error2, execute: executeIncomeList } = useAxios<IGetIncomeList>();
    const {data: expenseList, isLoading: isLoading3, error: error3, execute: executeExpenseList } = useAxios<IGetExpenseList>();

    useEffect(() => {
        const defaultDate = moment(new Date());
        setSrtDate(moment(defaultDate).format('YYYYMM01'));
        setEndDate(moment(defaultDate).format('YYYYMMDD'));
    },[]);

    const getAllListSearch = () => {
        getStudentIncome();
        getIncomeList();
        getExpenseList();
    }

    const getStudentIncome = () => {
        //최대 검색 기간 조건 추가
        const momentSrtDate = moment(srtDate);
        const momentEndDate = moment(endDate);
        const diffDay = moment.duration(momentEndDate.diff(momentSrtDate)).asDays();
        if(diffDay > 92) {
            return infoNotification(t('payment.inex.msg1'));
        }

        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);

        //파라미터 셋팅(form)
        const incomeListParam = new FormData();
        incomeListParam.append('campusCodes', campusCode.toString());
        incomeListParam.append('srtDate', srtDate);
        incomeListParam.append('endDate', endDate);
        incomeListParam.append('isHq', auth.hqYn);
        incomeListParam.append('pageNo', '1'); //page.toString()
        incomeListParam.append('perPage', maxPageSize.toString());

        executeList(getStudentIncomes(incomeListParam));
        setPage(1);
    }

    const getIncomeList = () => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);
        
        const incomeListParam: IIncomeListParams = {
            campusCodes: campusCode,
            searchType: 'ID',
            firstIncomeAccCode: '',
            secondIncomeAccCode: '',
            thirdIncomeAccCode: '',
            incomeMtd: '',
            incomeYn: '',
            incomeSrtDate: srtDate,
            incomeEndDate: endDate,
            incomeDesc: '',
            treeCommonCode: "FA0002",
            pageNo: 1,
            perPage: maxPageSize
        }
        //inPage

        executeIncomeList(getIncomes(incomeListParam));
        setInPage(1);
    }

    const getExpenseList = () => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);
        
        const expenseListParam: IExpenseListParams = {
            campusCodes: campusCode,
            searchType: 'ED',
            firstExpenseAccCode: '',
            secondExpenseAccCode: '',
            thirdExpenseAccCode: '',
            approvalStatus: 'CO',
            expenseMtd: '',
            expenseYn: '',
            expenseSrtDate: srtDate,
            expenseEndDate: endDate,
            title: '',
            treeCommonCode: "FA0001",
            commentYn: '',
            pageNo: 1,
            perPage: maxPageSize
        }
        //exPage

        executeExpenseList(getExpenses(expenseListParam));
        setExPage(1);
    }

    useEffect(() => {
        if(studentIncomeList) {
            let tempStudentIncomes : any[]  = _.cloneDeep(studentIncomeList.data);
            let tempTotalPrice: number = 0;
            let tempPaymentAmount: number = 0;
            let tempRefundAmount: number = 0;
            let tempDiscountAmount: number = 0;
            let tempunpaidAmount: number = 0;

            if (tempStudentIncomes.length > 0) {
                let tempNo = 1;
                tempStudentIncomes.forEach((item: IStudentIncome) => {
                    item.no = (pageSize * (page-1)) + tempNo;
                    tempNo++;
                    item.paymentCloseDate = (item.paymentCloseDate)?moment(item.paymentCloseDate).format("YYYY-MM-DD"):'';
                    item.paymentDttm = (item.paymentDttm)?moment(item.paymentDttm).format("YYYY-MM-DD"):'';
                    item.refundDttm = (item.refundDttm)?moment(item.refundDttm).format("YYYY-MM-DD"):'';
                    let tempTargetName = '';
                    if(item.paymentTargetCode === 'INEI') {
                        tempTargetName = t('payment.inex.label2');
                        item.monthNameCode = moment(item.paymentDttm).format("M");
                    } else {
                        tempTargetName = getCommonCodeLabel('PA0001', item.paymentTargetCode, i18n.language); 
                    }
                    item.paymentTargetCode = tempTargetName; 
                    item.monthNameCode = getCommonCodeLabel('SY0009', item.monthNameCode.trim(), 'ko');

                    //total
                    tempTotalPrice += Number(item.price);
                    tempPaymentAmount += Number(item.paymentAmount);
                    tempRefundAmount += Number(item.refundAmount);
                    tempDiscountAmount += Number(item.discountAmount);
                    tempunpaidAmount += Number(item.unpaidAmount);
                });
                
                tempStudentIncomes.unshift({
                    campusName:t('statistics.sales.column3'), currency:'KRW', price:tempTotalPrice, 
                    paymentAmount:tempPaymentAmount, refundAmount:tempRefundAmount,
                    discountAmount:tempDiscountAmount, unpaidAmount:tempunpaidAmount
                })
            }
            setStudentIncomeRefineList(tempStudentIncomes);
        }    
    }, [studentIncomeList]);

    useEffect(() => {
        if(incomeList) {
            let tempIncomeList : any[]  = _.cloneDeep(incomeList.data);
            let tempTotalOnline: number = 0;
            let tempTotalCash: number = 0;
            let tempTotalCard: number = 0;

            if (tempIncomeList.length > 0) {
                let tempNo = 1;
                tempIncomeList.forEach((item: any) => {
                    item.no = (config.pageSize * (page-1)) + tempNo;
                    tempNo++;
                    item.incomeDate = moment(item.incomeDate).format("YYYY-MM-DD");
                    item.registDate = moment(item.registDate).format("YYYY-MM-DD");
                    item.memberName = item.memberName + ((item.memberEngName) ? '(' + item.memberEngName + ')' : "");
                    item.online = item.incomeMtd === 'ON' ? item.amount : 0;
                    item.cash = item.incomeMtd === 'CS' ? item.amount : 0;
                    item.card = item.incomeMtd === 'CD' ? item.amount : 0;

                    //total
                    tempTotalOnline += item.online;
                    tempTotalCash += item.cash;
                    tempTotalCard += item.card;
                });

                tempIncomeList.unshift({campusName:t('cbt.test.column22'), online:tempTotalOnline, cash:tempTotalCash, card:tempTotalCard});
            }
            setIncomeRefineList(tempIncomeList);
        }
    }, [incomeList])

    useEffect(() => {
        if(expenseList) {
            let tempExpenseList : any[]  = _.cloneDeep(expenseList.data);
            let tempTotalOnline: number = 0;
            let tempTotalCash: number = 0;
            let tempTotalCard: number = 0;

            if (tempExpenseList.length > 0) {
                let tempNo = 1;
                tempExpenseList.forEach((item: any) => {
                    item.no = (config.pageSize * (page-1)) + tempNo;
                    tempNo++;
                    item.expenseDate = moment(item.expenseDate).format("YYYY-MM-DD");
                    item.registDate = moment(item.registDate).format("YYYY-MM-DD");
                    item.memberName = item.memberName + ((item.memberEngName) ? '(' + item.memberEngName + ')' : "");
                    item.currency = 'KRW';
                    item.online = item.expenseMtd === 'ON' ? item.amount : 0;
                    item.cash = item.expenseMtd === 'CS' ? item.amount : 0;
                    item.card = item.expenseMtd === 'CD' ? item.amount : 0;

                    //total
                    tempTotalOnline += item.online;
                    tempTotalCash += item.cash;
                    tempTotalCard += item.card;
                });
                tempExpenseList.unshift({campusName:t('cbt.test.column22'), online:tempTotalOnline, cash:tempTotalCash, card:tempTotalCard});
            }
            setExpenseRefineList(tempExpenseList);
        }
    }, [expenseList])

    const sharedOnCell = (_: any, index: number | undefined) => {
        if (_.no === undefined) {
          return { colSpan: 0 };
        }
      
        return {};
    };
      
    const columns: TableColumnsType<IStudentIncome> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
        },
        {
            title: t('common.menu.campus'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName),
            onCell: (record, index) => {
                return ({colSpan: (record.no === undefined) ? 8 : 1});
            }
        },
        {
            title: t('payment.inex.column6'),
            dataIndex: 'paymentCloseDate',
            key: 'paymentCloseDate',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.inex.column1'),
            dataIndex: 'paymentDttm',
            key: 'paymentDttm',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.inex.column2'),
            dataIndex: 'refundDttm',
            key: 'refundDttm',
            onCell: sharedOnCell,
        },
        {
            title: t('class.class.column57'),
            dataIndex: 'className',
            key: 'className',
            onCell: sharedOnCell,
        },        
        {
            title: t('student.student.column64'),
            dataIndex: 'memberCode',
            key: 'memberCode',
            onCell: sharedOnCell,
        },
        {
            title: t('class.class.column29'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2'),
            dataIndex: 'paymentTargetCode',
            key: 'paymentTargetCode',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.charge.column1'),
            dataIndex: 'monthNameCode',
            key: 'monthNameCode',
            align: 'center',
        },
        {
            title: t('payment.income.column3'),
            dataIndex: 'currency',
            key: 'currency',
            align: 'center'
        },
        {
            title: t('payment.inex.column3'),
            dataIndex: 'price',
            key: 'price',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.column90'),
            dataIndex: 'paymentAmount',
            key: 'paymentAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.column108'),
            dataIndex: 'refundAmount',
            key: 'refundAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.column39'),
            dataIndex: 'discountAmount',
            key: 'discountAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.column91'),
            dataIndex: 'unpaidAmount',
            key: 'unpaidAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
    ];

    const inColumns: TableColumnsType<any> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
        },
        {
            title: t('common.menu.campus'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName),
            onCell: (record, index) => {
                return ({colSpan: (record.no === undefined) ? 7 : 1});
            }
        },
        {
            title: t('payment.income.column1'),
            dataIndex: 'incomeDate',
            key: 'incomeDate',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2') + '1',
            dataIndex: 'firstIncomeAccName',
            key: 'firstIncomeAccName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.firstIncomeAccEngName),
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2') + '2',
            dataIndex: 'secondIncomeAccName',
            key: 'secondIncomeAccName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.secondIncomeAccEngName),
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2') + '3',
            dataIndex: 'thirdIncomeAccName',
            key: 'thirdIncomeAccName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.thirdIncomeAccEngName),
            onCell: sharedOnCell,
        },        
        {
            title: t('payment.income.search5'),
            dataIndex: 'incomeDesc',
            key: 'incomeDesc',
            align: 'center',
            render: value => (<div className='text-left ant-table-cell-ellipsis'>{value}</div>),
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.column3'),
            dataIndex: 'currency',
            key: 'currency',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.inex.column4'),
            dataIndex: 'cash',
            key: 'cash',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('entrance.schedule.option4'),
            dataIndex: 'online',
            key: 'online',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.inex.column5'),
            dataIndex: 'card',
            key: 'card',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('common.column.writer'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
        {
            title: t('statistics.articles.2'),
            dataIndex: 'registDate',
            key: 'registDate',
            align: 'center',
          },
    ];

    const exColumns: TableColumnsType<any> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
        },
        {
            title: t('common.menu.campus'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
            render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName),
            onCell: (record, index) => {
                return ({colSpan: (record.no === undefined) ? 7 : 1});
            }
        },
        {
            title: t('payment.expense.column1'),
            dataIndex: 'expenseDate',
            key: 'expenseDate',
            align: 'center',
            onCell: sharedOnCell,
        },
        
        {
            title: t('payment.income.search2') + '1',
            dataIndex: 'firstExpenseAccName',
            key: 'firstExpenseAccName',
            align: 'center',
            render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{i18n.language === 'ko' ? value : record.firstExpenseAccEngName}</div>),
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2') + '2',
            dataIndex: 'secondExpenseAccName',
            key: 'secondExpenseAccName',
            align: 'center',
            render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{i18n.language === 'ko' ? value : record.secondExpenseAccEngName}</div>),            
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.search2') + '3',
            dataIndex: 'thirdExpenseAccName',
            key: 'thirdExpenseAccName',
            align: 'center',
            render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{i18n.language === 'ko' ? value : record.thirdExpenseAccEngName}</div>),
            onCell: sharedOnCell,
        },
        {
            title: t('common.column.title'),
            dataIndex: 'title',
            key: 'title',
            align: 'center',
            render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{value}</div>),
            onCell: sharedOnCell,
        },
        {
            title: t('payment.income.column3'),
            dataIndex: 'currency',
            key: 'currency',
            align: 'center',
            onCell: sharedOnCell,
        },
        {
            title: t('payment.inex.column4'),
            dataIndex: 'cash',
            key: 'cash',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('entrance.schedule.option4'),
            dataIndex: 'online',
            key: 'online',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.inex.column5'),
            dataIndex: 'card',
            key: 'card',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('common.column.writer'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
        {
            title: t('statistics.articles.2'),
            dataIndex: 'registDate',
            key: 'registDate',
            align: 'center',
        },
    ];

    const onExportTable = () => {
        setExportTableLoading(true);
        const currentDate = moment(new Date());

        exportTable(columns, studentIncomeRefineList, `${t('payment.inex.label1')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.inex.label1')}`, [5,15,15,15,15,20,15,15,15,10,10,20,20,20,20,20] );

        setExportTableLoading(false);
    }

    const onIncomeExportTable = () => {
        setExportTableLoading(true);
        const currentDate = moment(new Date());

        exportTable(inColumns, incomeRefineList, `${t('payment.inex.label3')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.inex.label3')}`, [5,15,15,15,15,20,30,10,20,20,20,20,15] );

        setExportTableLoading(false);
    }

    const onExpenseExportTable = () => {
        setExportTableLoading(true);
        const currentDate = moment(new Date());

        exportTable(exColumns, expenseRefineList, `${t('payment.inex.label4')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.inex.label4')}`, [5,15,15,15,15,20,30,10,20,20,20,20,15] );

        setExportTableLoading(false);
    }

    return (
        <>
            {isLoading1 || isLoading2 || exportTableLoading ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            {
                                auth && (auth.hqYn === 'Y')
                                ? (
                                <>
                                    <SelectCampusMultiChoice
                                    placeholder={t('statistics.eLearning.title2')}
                                    onChange={setCampusCodes}
                                    value={campusCodes}
                                    />
                                    <label>
                                    ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
                                    </label>
                                </>
                                )
                                : <SelectCampus />
                            }
                        </li>
                        <li className="period">
                            <label>{t('sms.list.column1')}</label> {/* 기간 */}
                            <div className="comm-btn__area">
                                <FinancialDatePicker
                                    setStartDate={setSrtDate}
                                    setEndDate={setEndDate}
                                    type={DateTableType.Simple}
                                    defSelType={defSelType}
                                    setDefSelType={setDefSelType}
                                />
                            </div>
                            <div className="date-picker__area">
                                <DatePicker
                                value={srtDate ? moment(srtDate) : undefined}
                                onChange={e => {
                                    if (e === null) setSrtDate('');
                                    else setSrtDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            ~
                            <div className="date-picker__area">
                                <DatePicker
                                value={endDate ? moment(endDate) : undefined}
                                onChange={e => {
                                    if (e === null) setEndDate('');
                                    else setEndDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getAllListSearch()}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.inex.label1')}</h3>
            </div>
            <div className="comm-table__area">
                <Table
                    columns={columns}
                    dataSource={studentIncomeRefineList}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                    }}
                    rowKey={'no'}
                    rowClassName={(record: IStudentIncome) => record.campusCode === undefined ? 'tTotal' : ''}
                />
            </div>
            <div className="comm-bx__between">
                <DownloadButton onClick={onExportTable} />
                <div className="common-paging center">
                    <Pagination
                        count={(studentIncomeList?.total) ? studentIncomeList?.total + 1 : 0}
                        page={page}
                        setPage={setPage}
                        perPage={pageSize}
                    />
                </div>
            </div>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.inex.label3')}</h3>
            </div>
            <div className="comm-table__area">
                <Table
                    columns={inColumns}
                    dataSource={incomeRefineList}
                    pagination={{
                        current: inPage,
                        pageSize: pageSize,
                    }}
                    rowKey={'no'}
                    rowClassName={(record: IIncomeList) => record.campusCode === undefined ? 'tTotal' : ''}
                />
            </div>
            <div className="comm-bx__between">
                <DownloadButton onClick={onIncomeExportTable} />
                <div className="common-paging center">
                    <Pagination
                        count={(incomeList?.total) ? incomeList?.total + 1 : 0}
                        page={inPage}
                        setPage={setInPage}
                        perPage={pageSize}
                    />
                </div>
            </div>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.inex.label4')}</h3>
            </div>
            <div className="comm-table__area">
                <Table
                    columns={exColumns}
                    dataSource={expenseRefineList}
                    pagination={{
                        current: exPage,
                        pageSize: pageSize,
                    }}
                    rowKey={'no'}
                    rowClassName={(record: IExpenseList) => record.campusCode === undefined ? 'tTotal' : ''}
                />
            </div>
            <div className="comm-bx__between">
                <DownloadButton onClick={onExpenseExportTable} />
                <div className="common-paging center">
                    <Pagination
                        count={(expenseList?.total) ? expenseList?.total + 1 : 0}
                        page={exPage}
                        setPage={setExPage}
                        perPage={pageSize}
                    />
                </div>
            </div>
        </>
    )
}

export default IncomeExpenseList;